<template>
	<section>
		<bread-crumb></bread-crumb>
		<div class="first-wrap">
			<div class="nav-wrap">
				<span v-for="(item, index) in tabs" :key="index" :class="isClick == index ? 'current' : ''" @click="changeTabs(item, index)">{{ item.name }}</span>
			</div>
			<div class="search-wrap">
				<img src="../../assets/img/search.png" class="search-icon" />
				<input type="text" ref="input1" v-model.trim="keyword" @keyup.13="search" placeholder="请输入订单编号、买家旺旺查找" />
				<img src="../../assets/img/go.png" class="go-icon" />
			</div>
		</div>

		<!-- 1待支付 2待处理 3 处理中 4待确认 5已完成 6已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
		<ul class="order-wrap">
			<li v-for="(item, index) in orderList" :key="index">
				<div class="order-top" :class="item.order_status == 1 || item.order_status == 3 || item.order_status == 11 ? 'back-active' : ''">
					<p class="order_no">
						订单编号：
						<span>{{ item.order_code }}</span>
					</p>
					<p class="maijia">
						<span v-text='item.server_type == 1?"买家旺旺：":"顾客名称："'></span>
						<span v-text='item.server_type == 1?item.consumer_wangwang:item.consumer_name'></span>
					</p>
					<p>
						下单时间：
						<span>{{ item.create_time }}</span>

					</p>

          <p v-if="['4','5','8','9','10','11','7'].includes(item.order_status)">
			  <i class="el-icon-delete" slot="reference" @click="delOrder(item)"></i>
		  </p>
				</div>

				<div class="order-bottom">
					<div class="order-title">
						<img src="../../assets/img/taoBao.png" />
						<span>{{ item.server_info.server_name }}</span>
					</div>
					<el-divider direction="vertical"></el-divider>
					<span class="money">{{ item.order_total_price }}元</span>
					<el-divider direction="vertical"></el-divider>
					<div class="system-cancel">
						<span class="status" :class="item.order_status == 7 || item.order_status == 9 ? 'status-active' : ''">{{ item.statusName }}</span>
						<div v-if='item.statusName=="已取消" && item.is_system_cancel==2'>订单超时未付款，自动取消</div>
					</div>

					<el-divider direction="vertical"></el-divider>

					<!-- 1.待支付 -->
					<div class="operate-wrap" v-if="item.order_status == 1">
						<div class="pay" @click.stop="payMent(index, item)">付款</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 3.处理中 -->
					<div class="operate-wrap" v-else-if="item.order_status == 3 || item.order_status == 13">
						<div class="refund" @click.stop="refundComplete(index, item)" v-if="item.isOverFive">退款</div>
						<div class="debunk" @click.stop="isPlanShow = true" v-else>退款</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 4待确认 -->
					<div class="operate-wrap" v-else-if="item.order_status == 4">
						<div class="refund" @click.stop="reject(item)">驳回</div>
						<div class="refund" @click.stop="refundComplete(index, item)">完成</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 5已完成 -->
					<div class="operate-wrap" v-else-if="item.order_status == 5">
						<div class="refund" v-if="item.is_comment == 1" @click.stop="comment(index, item)">吐槽</div>
						<div class="debunk" v-if="item.is_comment == 2" @click.stop="">已吐槽</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 8 已驳回 -->
					<div class="operate-wrap" v-else-if="item.order_status == 8">
						<div class="refund" @click.stop="refundComplete(index, item)">完成</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 9已退款 10退款中 11未解决 -->
					<div class="operate-wrap" v-else-if="item.order_status == 9 || item.order_status == 10 || item.order_status == 11">
						<div class="debunk" @click.stop="refundComplete(index, item)" v-if="item.order_status == 9">退款</div>
						<div class="debunk" @click.stop="refundComplete(index, item)" v-else-if="item.order_status == 10">退款</div>
						<div class="refund" @click.stop="refundComplete(index, item)" v-else>退款</div>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- 2待处理  6已撤单 7 取消订单 -->
					<div class="operate-wrap" v-else>
						<p @click="toDetail(item)">详情</p>
					</div>

					<!-- <div class="operate-wrap">
				<div class="pay" v-if="item.order_status == 1" @click.stop="payMent(index)">付款</div>
				<div class="refund" v-if="item.order_status == 11" @click.stop="refund(index)">退款</div>
				<div class="debunk" v-if="item.order_status == 5 && item.is_comment == 1" @click.stop="comment(index)">吐槽</div>
				<p :class="item.order_status == 7 ? 'active' : ''">订单详情</p>
			</div> -->
				</div>
			</li>
		</ul>

		<!-- 退款详情页弹框 -->
		<refund-modal v-if="isRefund" @backList="isRefund=false" :order_uuid="order_uuid" @close="isRefund = false"></refund-modal>

		<!-- 驳回弹框 -->
		<reject-modal v-show="isRejectShow" @close="isRejectShow = false" ref="reject"></reject-modal>

		<!-- 超过5天直接退款,完成订单 -->
		<common-tips v-if="isCommonShow" :is-show-close="isShowClose" @close="isCommonShow = false" :tip-data="tipData"
		 @submitTips="submitTips"></common-tips>

		<!-- 保障计划 -->
		<support-plan-modal v-if="isPlanShow" @close="isPlanShow = false" @showAgreeMent="isShowAgree = true"></support-plan-modal>

		<!-- 下单协议 -->
		<agree-ment-modal v-if="isShowAgree" @close="isShowAgree = false;isPlanShow = true"></agree-ment-modal>

		<!-- 吐槽弹框 -->
		<comment-modal v-show="isCommentShow" @close="isCommentShow = false" @commentBack="getOrderList()" ref="comment"></comment-modal>

		<!-- 支付成功弹框 -->
		<pay-success-modal v-if="isSuccess" :charge-money="chargeMoney" :order_uuid="order_uuid" type="pay" @backList="backList"></pay-success-modal>

		<!-- 支付弹框 -->
		<pay-modal @close="close" @getCallBack="getCallBack" v-if="isPayModal" :order_uuid="order_uuid" :charge-money="chargeMoney"
		 :order_member_price="order_member_price" type="pay" ref="payModal"></pay-modal>

		<common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange" @page-change="handlePageChange"></common-pagination>
	</section>
</template>

<script>
	import utils from '@/assets/js/utils';
	import BreadCrumb from '@/components/BreadCrumb.vue';
	import CommonPagination from '@/components/CommonPagination';
	import commonTips from '@/components/commonTips';
	import agreeMentModal from '@/components/agreeMentModal';
	import supportPlanModal from '@/components/supportPlanModal';
	import commentModal from '@/components/commentModal';
	import rejectModal from '@/components/rejectModal';
	import payModal from '@/components/payModal';
	import paySuccessModal from '@/components/paySuccessModal';
	import refundModal from '@/components/refundModal';
	import {
		getOrderList,
		getOrderPay,
		getOrderDetail,
		getOrderComment,
		operateOrder,
    delOrders
	} from '@/api/order.js';
	export default {
		components: {
			BreadCrumb,
			CommonPagination,
			commonTips,
			agreeMentModal,
			supportPlanModal,
			payModal,
			commentModal,
			rejectModal,
			paySuccessModal,
			refundModal
		},
		data() {
			return {
				isPayModal: false,
				chargeMoney: '',
				total: 0,
				page_index: '1', // 第几页
				page_size: '10',
				isClick: 0,
				tabCur: 1, // 筛选订单
				tabs: [{
						name: '全部',
						status: '1'
					},
					{
						name: '处理中',
						status: '3'
					},
					{
						name: '待付款',
						status: '2'
					},
					{
						name: '未解决',
						status: '5'
					},
					{
						name: '已完成',
						status: '4'
					}
				],
				count: '',
				clickPay: true, // 是否可以点击支付
				qrcodeUrl: '', // 支付二维码链接
				order_uuid: '',
				order_member_price: '', // 优惠价格
				orderList: [],
				keyword: '',
				searchTimer: null, // 搜索截流
				tipData: {},
				isShowClose: false,
				isCommonShow: false,
				isCommentShow: false,
				isPlanShow: false,
				isShowAgree: false,
				isRejectShow: false,
				isSuccess: false,
				isRefund: false,
				clickOperate:true			//是否可以操作弹框
			};
		},

		watch: {
			keyword() {
				this.clearTimer();
				this.searchTimer = setTimeout(() => {
					this.tabCur = 1;
					this.page_index = 1;
					this.getOrderList('1');
				}, 500);
				if (!this.keyword) {
					this.$refs.input1.blur();
				}
			}
		},

		created() {
			this.getOrderList();
		},

		methods: {
			async getOrderList() {
				const obj = {
					status: this.tabCur,
					keyword_search: this.keyword,
					page_index: this.page_index,
					page_size: this.page_size
				};
				const {
					data,
					status
				} = await getOrderList(obj);
				if (status !== 200) return;
				this.orderList = data.data;
				this.total = data.total;
				this.orderList.forEach((item, index) => {
					item.statusName = utils.statusToName(item.order_status);
					if (item.statusName == '已撤单' || item.statusName == '待处理' || item.statusName == '已撤回') {
						item.statusName = '处理中';
					}
					const createTime = new Date(item.create_time.replace(/-/g,"/")).getTime(); // 支付时间
					const noweTime = new Date().getTime(); // 当前时间
					const fiveDayTime = 5 * 24 * 60 * 60 * 1000;
					if (noweTime - createTime > fiveDayTime) {
						// 超过5天
						this.$set(item, 'isOverFive', true);
					} else {
						this.$set(item, 'isOverFive', false);
					}
					item.clickPay = true; // 是否支付的标示
				});
			},

			handelPagesizeChange(size) {
				this.page_size = size;
				this.getOrderList();
			},

			handlePageChange(page) {
				this.page_index = page;
				this.getOrderList();
			},

      //删除订单
      async delOrder(item){


          this.$confirm('删除后可找管理员恢复', '是否删除订单？', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
			  delOrders(item.uuid);
              this.$message.success('删除成功');
              this.search();
          }).catch(() => {
              /*this.$message({
                  type: 'info',
                  message: '已取消删除'
              });*/
          });

      },
			// 筛选订单
			changeTabs(item, index) {
				this.page_index = 1;
				this.tabCur = item.status;
				this.orderList = [];
				this.isClick = index;
				this.getOrderList(this.tabCur);
			},

			// 立即评价
			comment(index, item) {
				const server_icon = item.server_info.server_icon;
				const server_name = item.server_info.server_name;
				this.isCommentShow = true;
				this.count = index;
				this.order_uuid = item.uuid;
				this.$refs.comment.getCommentInfo(this.order_uuid, server_icon, server_name);
			},

			// 驳回
			reject(item) {
				this.isRejectShow = true;
				this.order_uuid = item.uuid;
				this.$refs.reject.getCommentInfo(this.order_uuid);
			},

			// 超过5天直接退款,完成订单,查看退款详情
			refundComplete(index, item) {
				this.count = index;
				this.order_uuid = item.uuid;
				if (item.order_status == 3 || item.order_status == 11) {
					this.tipData = {
						title: '确定要申请退款么？',
						content: '申请退款后，款项48小时内原路退回。',
						num: 1
					};
					this.isCommonShow = true;
				} else if (item.order_status == 4 || item.order_status == 8) {
					// 完成
					this.tipData = {
						title: '确定要完成订单么？',
						content: '是否确认完成当前订单。',
						num: 2
					};
					this.isCommonShow = true;
				} else {
					this.isRefund = true;
				}
			},

			// 确定超过5天直接退款,完成订单
			submitTips(num) {
				switch (Number(num)) {
					case 1:
						this.operateOrder('5');
						break;
					case 2:
						this.operateOrder('2');
						break;
				}
			},

			// 操作订单
			async operateOrder(type, reason_for_rejection = '') {
				if(!this.clickOperate) {
					window.toast("请勿重复点击","txt");
					return;
				}
				this.clickOperate = false;
				setTimeout(()=>{
					this.clickOperate = true;
				},2000)
				const parmas = {
					type: type,
					reason_for_rejection: reason_for_rejection
				};
				const {
					data,
					status
				} = await operateOrder(this.order_uuid, parmas);
				if (status !== 200) return;
				if (type == '5') {
					// 退款
					this.isCommonShow = false;
					this.isRefund = true;
				} else if (type == '2') {
					this.getOrderList();
					this.$message.success('订单已完成')
					this.isCommonShow = false;
				}
			},

			// 立即支付
			payMent(index, item) {
				this.isPayModal = true;
				this.count = index;
				this.order_uuid = item.uuid;
				this.clickPay = item.clickPay;
				this.chargeMoney = item.order_total_price;
				this.order_member_price = item.order_member_price;
				this.$nextTick(() => {
					this.$refs.payModal.payClick(1);
				})
			},

			// 支付成功的回调
			getCallBack() {
				this.$nextTick(() => {
					this.isSuccess = true;
				})
			},

			close() {
				this.isPayModal = false;
			},

			// 支付成功查看订单列表
			backList() {
				this.getOrderList();
				this.isSuccess = false;
			},

			clearTimer() {
				if (this.searchTimer) {
					clearTimeout(this.searchTimer);
				}
			},

			search() {
				this.$refs.input1.blur();
				this.tabCur = 1;
				this.page_index = 1;
				this.getOrderList('1');
			},

			toDetail(item) {
				this.$router.push({
					path: './order-detail',
					query: {
						order_uuid: item.uuid
					}
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	input::-webkit-input-placeholder {
		/* WebKit browsers 适配谷歌 */
		font-size: 14px;
		color: rgba(38, 60, 82, 1);
		font-family: Microsoft YaHei;
		opacity: 0.3;
	}

	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 适配火狐 */
		font-size: 14px;
		font-family: Microsoft YaHei;
		color: rgba(38, 60, 82, 1);
		opacity: 0.3;
	}

	input::-moz-placeholder {
		/* Mozilla Firefox 19+ 适配火狐 */
		font-size: 14px;
		font-family: Microsoft YaHei;
		color: rgba(38, 60, 82, 1);
		opacity: 0.3;
	}

	input:-ms-input-placeholder {
		/* Internet Explorer 10+  适配ie*/
		font-size: 14px;
		font-family: Microsoft YaHei;
		color: rgba(38, 60, 82, 1);
		opacity: 0.3;
	}

	.first-wrap {
		margin-top: 20px;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.nav-wrap {
			span {
				margin-right: 58px;
				cursor: pointer;
				font-size: 20px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #999999;
			}

			span:last-child {
				margin-right: 0;
			}

			.current {
				color: #ff8d1b;
			}
		}

		.search-wrap {
			width: 300px;
			padding: 0 20px;
			height: 50px;
			border-radius: 6px;
			background: #ffffff;
			box-shadow: 1px 13px 20px 1px rgba(0, 0, 0, 0.06);
			display: flex;
			align-items: center;

			.search-icon {
				width: 15px;
				height: 14px;
			}

			.go-icon {
				width: 13px;
				height: 13px;
			}

			input {
				flex: 1;
				outline: none;
				padding-left: 10px;
			}
		}
	}

	.order-wrap {
		li {
			cursor: pointer;
			margin-bottom: 20px;

			.order-top {
				height: 48px;
				background: #eff1f5;
				line-height: 48px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 40px;

				p {
					font-size: 16px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #5f6165;
				}

				.order_no {
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					width: 23%;
				}

				.maijia {
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					width: 30%;
				}
			}

			.back-active {
				background: #fff3e5;
			}

			.order-bottom {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 120px;
				padding-left: 60px;
				padding-right: 60px;
				background: #ffffff;
				box-shadow: 0px 3px 6px 0px rgba(101, 101, 101, 0.16);

				span {
					font-size: 20px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #333333;
				}

				.status {
					font-weight: bold;
					color: #ff9022;
				}

				.status-active {
					color: #cbcbcb;
				}

				.order-title {
					display: flex;
					align-items: center;
                    width: 190px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
					img {
						width: 20px;
						height: 20px;
						margin-right: 10px;
					}
				}
                .money{
                    width: 130px;
                    text-align: center;
                }

				.operate-wrap {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 220px;

					div {
						width: 80px;
						height: 40px;
						line-height: 40px;
						text-align: center;
						border-radius: 5px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						margin-right: 10px;
					}

					.pay {
						background: #ff8d1b;
						color: #ffffff;
					}

					.refund {
						background: #ff8d1b;
						color: #ffffff;
					}

					.debunk {
						background: #fff3e5;
						color: #ff9022;
					}

					p {
						font-size: 18px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #656565;
						text-align: center;
					}

					.active {
						color: #ff9f40;
					}
				}

				>>>.el-divider {
					height: 60px;
					background: #cbcbcb;
					opacity: 0.5;
				}
				.system-cancel{
					width: 170px;
					text-align: center;
					div{
						font-size: 14px;
						color: #999;
						margin-top: 5px;
					}
				}
			}
		}

		li:last-child {
			margin-bottom: 0;
		}
	}
</style>
